import React, { useState } from "react";
import { Layout } from "antd";
import ImportDashboard from "./ImportDashboard";
import Sidebar from "../components/Sidebar";
import AppHeader from "../components/Header";
import "./ImportDashboard.css";

const { Content } = Layout;

export default function ImportView() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout style={{ minHeight: "100vh", background: "#f7f8fc" }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />

      <Layout>
        <AppHeader />
        <Content className="import-page-content">
          <ImportDashboard />
        </Content>
      </Layout>
    </Layout>
  );
}